import { APP_NAME } from '@trellis/shared'

import type { FileRouteTypes } from '@/routeTree.gen'

type RouteFullPath = FileRouteTypes['fullPaths']

export const PAGE_TITLES: Record<RouteFullPath, string> = {
  '/': 'Overview',
  '/2fa-setup': 'Set up two-factor authentication',
  '/forgot-password': 'Forgot password',
  '/login': 'Sign in',
  '/login/verify-2fa': 'Verify two-factor authentication',
  '/onboarding': 'Onboarding',
  '/reset-password': 'Reset password',
  '/setup': 'Set up your account',
  '/verify-email': 'Verify email',
  '/workspaces': 'Choose a workspace',
  '/clients/': 'Clients',
  '/clients/$id/': 'Client',
  '/clients/$id/edit/': 'Edit client',
  '/clients/import/': 'Import clients',
  '/clients/import/$id/': 'Client import',
  '/clients/new/': 'New client',
  '/expenses/': 'Expenses',
  '/expenses/$id/': 'Expense',
  '/expenses/$id/edit/': 'Edit expense',
  '/expenses/import/': 'Import expenses',
  '/expenses/import/$id/': 'Expense import',
  '/expenses/new/': 'New expense',
  '/expenses/recurring/$id/': 'Recurring expense',
  '/expenses/recurring/$id/edit/': 'Edit recurring expense',
  '/expenses/recurring/$id/runs/': 'Recurring expense runs',
  '/invoices/': 'Invoices',
  '/invoices/$id/': 'Invoice',
  '/invoices/$id/edit/': 'Edit invoice',
  '/invoices/import/': 'Import invoices',
  '/invoices/import/$id/': 'Invoice import',
  '/invoices/new/': 'New invoice',
  '/invoices/recurring-invoices/$id/': 'Recurring invoice',
  '/invoices/recurring-invoices/$id/edit/': 'Edit recurring invoice',
  '/invoices/recurring-invoices/new/': 'New recurring invoice',
  '/line-items/': 'Line items',
  '/line-items/$id/': 'Line item',
  '/line-items/$id/edit/': 'Edit line item',
  '/line-items/import/': 'Import line items',
  '/line-items/import/$id/': 'Line item import',
  '/line-items/new/': 'New line item',
  '/quotes/': 'Quotes',
  '/quotes/$id/': 'Quote',
  '/quotes/$id/edit/': 'Edit quote',
  '/quotes/import/': 'Import quotes',
  '/quotes/import/$id/': 'Quote import',
  '/quotes/new/': 'New quote',
  '/recurring-invoices/': 'Recurring invoices',
  '/recurring-invoices/$id/': 'Recurring invoice',
  '/recurring-invoices/$id/edit/': 'Edit recurring invoice',
  '/recurring-invoices/new/': 'New recurring invoice',
  '/reports/': 'Reports',
  '/settings': 'Settings',
  '/settings/': 'Settings',
  '/settings/dev-mode/': 'Dev mode',
  '/settings/organization/': 'Business settings',
  '/settings/organization/access/': 'Access settings',
  '/settings/organization/accounting-export/': 'Accounting export',
  '/settings/organization/branding/': 'Branding',
  '/settings/organization/invoicing/': 'Invoicing settings',
  '/settings/organization/notifications/': 'Notification settings',
  '/settings/organization/payment-options/': 'Payment options',
  '/settings/organization/payment-options/stripe/return/': 'Stripe connection',
  '/settings/organization/reminders/': 'Reminder settings',
  '/settings/organization/tax/': 'Tax and legal',
  '/settings/payments/stripe/return/': 'Stripe connection',
  '/settings/privacy/': 'Privacy',
  '/settings/profile/': 'Profile',
  '/settings/security/': 'Security',
  '/settings/tags/': 'Tags',
  '/settings/terms-of-service/': 'Terms of Service',
  '/settings/terms-templates/': 'Terms templates',
  '/settings/theme/': 'Theme',
  '/settings/users/': 'Users',
}

export function resolveDocumentTitle(matches: readonly { fullPath: string }[]): string {
  const leafPath = matches.at(-1)?.fullPath
  const pageTitle = leafPath
    ? (PAGE_TITLES as Record<string, string>)[leafPath]
    : undefined
  return pageTitle ? `${pageTitle} | ${APP_NAME}` : APP_NAME
}

export function applyDocumentTitle(matches: readonly { fullPath: string }[]): void {
  document.title = resolveDocumentTitle(matches)
}
